// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

export const isAppsApiLimitsCompanyRateLimitDatatableResult = objectOf({
  hits: number,
  results: arrayOf(
    objectOf({
      id: string,
      endpoint: string,
      rate_limit: objectOf({
        limit: number,
        period: number,
      }),
      type: string,
      last_changed_timestamp: string,
    })
  ),
});
